import { environment } from '@env/environment';
import { ItemDto } from './item.dto';

export abstract class ItemAbstract {
    patternName: string;
    name: string;
    slug: string;
    categories: string[];
    imageUrl: string;
    parameters: {
        atrapa: boolean;
        grupa: string;
        width: number | string;
        height: number | string;
        width_z_kam: number;
        height_z_kam: number;
        price: number;
        price_z_kam: number;
        stone_label: string;
    };
}

export class Item implements ItemAbstract {
    patternName: string;
    name: string;
    slug: string;
    categories: string[];
    imageUrl: string;
    parameters: {
        atrapa: boolean;
        grupa: string;
        width: number;
        height: number;
        width_z_kam: number;
        height_z_kam: number;
        price: number;
        price_z_kam: number;
        stone_label: string;
    };

    constructor(dto: ItemDto) {
        this.patternName = dto.patternName;
        this.name = dto.name;
        this.slug = dto.slug;
        this.categories = [];
        this.imageUrl = environment.serverUrl + `api/public/product/catalogue/image/${this.patternName}?timestamp=${Date.now()}`;
        this.parameters = {
            atrapa: dto.parameters.atrapa === '1',
            grupa: dto.parameters.grupa,
            width: parseFloat(dto.parameters.width),
            height: parseFloat(dto.parameters.height),
            width_z_kam: isNaN(parseFloat(dto.parameters.width_z_kam)) ? null : parseFloat(dto.parameters.width_z_kam),
            height_z_kam: isNaN(parseFloat(dto.parameters.height_z_kam)) ? null : parseFloat(dto.parameters.height_z_kam),
            price: parseFloat(dto.parameters.price),
            price_z_kam: parseFloat(dto.parameters.price_z_kam),
            stone_label: dto.parameters.stone_label,
        };
    }
}
